import { resetChatRegistryIdentityState } from "./chatRegistry.js";
import { resetDockIdentityState } from "./dockStore.js";

import { resetNavigationIdentityState } from "./navigationStore.js";
import { resetStarterCardsIdentityState } from "./starterCardsStore.js";
import { resetTenantViewCloudIdentityState } from "./tenantViewCloudStore.js";

// Module stores survive React remounts. Clear every store that can expose a
// closure or first-frame snapshot from the prior authenticated identity while
// AuthIdentityGate is blank and before the replacement App mounts.
export function resetTenantDerivedUiState() {
    resetStarterCardsIdentityState();
    resetDockIdentityState();
    resetChatRegistryIdentityState();
    resetNavigationIdentityState();
    resetTenantViewCloudIdentityState();
}
